import { SUCCESS_STORIES } from '@/data/content';

const initials = (name) => name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);

const SuccessStories = ({ limit }) => {
  const list = limit ? SUCCESS_STORIES.slice(0, limit) : SUCCESS_STORIES;

  return (
    <section data-testid="stories-section">
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Success Stories</div>
          <h2 className="section-title">Our Students <span className="gold-gradient">Living the Dream</span></h2>
          <p className="section-subtitle">
            Real students. Real admissions. Real success in Europe's top universities — from Politecnico di Milano to the University of Bologna.
          </p>
        </div>

        <div className="story-grid">
          {list.map((s) => (
            <div key={s.id} className="story-card" data-testid={`story-${s.id}`}>
              <div className="story-avatar">{initials(s.name)}</div>
              <h3 className="story-name">{s.name}</h3>
              <div className="story-program">{s.program}</div>
              <div className="story-uni">{s.university}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
